// extracted by mini-css-extract-plugin
export var content = "_v4-1";
export var wrapper = "_v4-0";